import React, { useEffect, useState } from "react";
import { Box, Typography, Grid, Autocomplete, TextField, Button } from '@mui/material';
import Card from "../../components/card/Card";
import ActionButton from "../../components/actionButton";
import TableContainer from "../../components/table/table";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SearchBar from "../../components/searchBar/searchBar";
import moment from "moment";
import { createPo } from "../../store/actions/po";
import add from '../../assets/add.png';
import { filterName } from "../../utils/Utils";
import SelectedProduct from "../../components/selected";
import { getAllWarehouseProductPaging } from "../../store/actions/warehouse";
import ModalButton from "../../components/modalButton/modalButton";
import FillRequestData from "./fillRequestData";
import SaveButton from "../../components/saveButton/saveButton";
import RFTSOtherVendors from "./rftsOtherVendors";
import { useForm } from "react-hook-form";
import InputFields from "../../components/InputFields";
import SelectFields from "../../components/SelectFields";
import ButtonContainer from "../../components/buttonContainer";
import { emptyWarehouseProductPaging } from "../../store/reducers/warehouse-slice";

const RFTS = () => {
    const dispatch = useDispatch();
    const { user } = useSelector(state => state.auth)
    const navigation = useNavigate()
    const location = useLocation()
    const { state } = location
    console.log(state)

    const { wearhouseList, vendorList, medicationTypeList } = useSelector(state => state.filler)
    const { warehouseProductPaging, wearhouseProductPagingcount } = useSelector(state => state.warehouse)

    const [isLoading, setIsLoading] = useState(false);
    const [isSaveLoading, setIsSaveLoading] = useState(false);
    const [Products, setProducts] = useState([])
    const [ProductsList, setProductsList] = useState([])
    const [orderList, setOrderList] = useState([])
    const [orderListDetails, setOrderListDetails] = useState([])
    const [search, setSearch] = useState('')
    const [wearhouse, setWearhouse] = useState('')


    const [openOtherVendor, setOpenOtherVendor] = useState(false)
    const [zeroItems, setZeroItems] = useState([])
    const [sameProduct, setSameProduct] = useState([])

    const tableHeader = ['DIN Number', 'Vendor', 'Product Name', 'Type of Medication', 'Strenght', 'Available Quantity']
    const verifyParam = ['diN_Master', 'vendorValue', 'productName', 'dosageValue', 'mg', 'productQty']
    const selectedHeader = ['DIN Number', 'Vendor', 'Product Name', 'Strenght', 'Pack Size', 'Available Quantity', 'Quantity Required']
    const selectedParam = ['diN_Master', 'vendorValue', 'productName', 'mg', 'PackSize', 'productQty', 'Qty']


    const defaultValues = useForm({
        defaultValues: {
            Din_Number: "",
            Vendor_ID: "",
            ProductName: "",
            Strength: "",
            comment: "",
        },
    });

    const {
        control,
        handleSubmit,
        setError,
        clearErrors,
        watch,
        reset,
        resetField,
        getValues,
        formState: { errors },
    } = defaultValues;


    useEffect(() => {
        console.log(user)
        if (wearhouse) {
            // fetchList()
        }
        return () => {
            dispatch(emptyWarehouseProductPaging())
        }
    }, [wearhouse, search])




    const fetchList = (obj, rowsPerPage, page) => {
        const allEmpty = Object.values(getValues()).every(v => !v);
        
        console.log(allEmpty)
        if (allEmpty) {
            alert("Please fill at least one field");
            return;
        }
        setIsLoading(true)
        let data = {
            "sid": null,
            "lid": null,
            "reqInfo": null,
            "msgType": "GETALLWEARHOUSEPRODUCTPAGING",
            "data": {
                "WearHouse_ID": 4,
                'PageIndex': page ? page + 1 : 1,
                "PageSize": rowsPerPage ? rowsPerPage : 10,
                "Filter": watch('Din_Number') ? watch('Din_Number') : null,
                "Vendor_ID": watch('Vendor_ID') ? watch('Vendor_ID') : null,
                "ProductName": watch('ProductName') ? watch('ProductName') : null,
                "Strength": watch('Strength') ? watch('Strength') : null
            },
            "debug": null,
            "token": null
        }
        dispatch(getAllWarehouseProductPaging(data)).then(res => {
            setIsLoading(false)
            if (state?.wearHouseName) {
                getRFMKeysFromLocalStorage()
            }
        })
    }
    useEffect(() => {
        if (state?.wearHouseName) {
            setWearhouse(wearhouseList.find(e => (e.name == state?.wearHouseName))?.id)
        }
    }, [])
    const getRFMKeysFromLocalStorage = () => {
        const rfmItems = [];

        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key.includes('RFM')) {
                const value = localStorage.getItem(key);
                setOrderList(JSON.parse(value))
                rfmItems.push({ key, value });
            }
        }
        return rfmItems;
    };

    useEffect(() => {
        let arr = []
        warehouseProductPaging.forEach((ele) => {
            const obj = { ...ele }
            obj['vendorValue'] = filterName(vendorList, obj.vendor_ID);
            obj['dosageValue'] = filterName(medicationTypeList, obj.dosage_ID);
            obj['Qty'] = '';
            arr.push(obj)
        })
        console.log(warehouseProductPaging)
        setProducts(arr)
        setProductsList(arr)

    }, [warehouseProductPaging, wearhouse])


    const submit = () => {
        console.log(getValues(), sameProduct)
        if (orderList.length > 0) {
            // setIsSaveLoading(true)
            let checkQuantity = orderList.map(e => {
                return ({
                    ...orderListDetails.filter(val => val.product_ID == e.Product_ID)[0],
                    Qty: e?.Qty,
                    PackSize: e.PackSize
                })
            })
            checkQuantity.filter(val => console.log(val.product_ID, sameProduct))
            console.log(checkQuantity)
            let zeroItemsList = checkQuantity.filter(val => val.productQty == 0 && !sameProduct?.includes(val.product_ID))
            console.log(zeroItemsList)
            if (zeroItemsList.length > 0 || (sameProduct.length > 0 && watch('comment') === '')) {
                setOpenOtherVendor(true)
                setZeroItems(zeroItemsList)
            } else {
                let list = orderList.map(e => ({ ...e, "RFTSDate": String(new Date()) }))
                let data = {
                    "sid": null,
                    "lid": null,
                    "reqInfo": null,
                    "msgType": "INSERTRFTSREALTEDRECORD",
                    "data": list.map(e => ({ ...e, Comments: watch('comment'), IsProceedWSame: sameProduct.includes(e.Product_ID) })),
                    "debug": null,
                    "token": null
                }
                console.log(data)
                dispatch(createPo(data)).then(res => {
                    localStorage.removeItem(`RFM${filterName(wearhouseList, wearhouse)}_${moment(new Date()).format("YYYY-MM-DD")}`)
                    setIsSaveLoading(false)
                    navigation(-1)
                })
            }

        }
    }

    const addOrderList = (obj, index) => {
        let arr = [...orderList]
        let products = [...orderListDetails]
        obj.map(ele => {
            console.log(ele)
            if (ele.Qty != '') {
                arr.push({ "productName": ele.productName, 'mg': ele.mg, "Qty": ele.Qty, "PackSize": ele.packSize_Detail, "Product_ID": ele.product_ID, "ProductDetail_ID": ele.productDetail_ID, "CreateBy": user?.userId, "FromLocationID": 4, "FromLocationTypeID": 1, "ToLocationID": user.locationID, "ToLocationTypeID": 2, "RFTSDate": String(new Date()) })
                setOrderList(arr)
                localStorage.setItem(`RFM${filterName(wearhouseList, wearhouse)}_${moment(new Date()).format("YYYY-MM-DD")}`, JSON.stringify(arr))
                products.push({
                    ...ProductsList.filter(val => val.product_ID == ele.product_ID)[0],
                })
                setOrderListDetails(products)
            }
        })

    }

    const onRemove = (data, index) => {
        console.log(sameProduct, data.product_ID)
        if (sameProduct.length > 0) {
            let arrSameProduct = [...sameProduct]
            const sameProductIndex = arrSameProduct?.findIndex(val => val == data.product_ID)
            arrSameProduct?.splice(sameProductIndex, 1)
            setSameProduct(arrSameProduct)
        }
        const obj = {
            ...data,
            Qty: ""
        }
        let arr = [...Products]
        arr.unshift(obj)
        setProducts(arr)
        orderList.splice(index, 1)
        setOrderList(orderList)
    }

    const TableAction = ({ data }) => {
        const [open, setOpen] = React.useState(false);
        return (
            <>
                <ModalButton open={open} setOpen={setOpen} tooltip={'Request products'} img={add} type={'icon'}>
                    <FillRequestData data={data.id} addOrderList={addOrderList} />
                </ModalButton>
            </>
        )
    }
    const otherVendor = (data) => {
        const productDetailId = data.subProduct.find(val => val.productDetailQty > 0).productDetail_ID
        orderListDetails.push(data)
        setOrderListDetails(orderListDetails)
        let obj = {
            ...orderList.find(val => val.productName == data.productName && val.mg == data.mg),
            Product_ID: data.product_ID,
            ProductDetail_ID: productDetailId
        }
        const index = orderList.findIndex(val => val.productName == data.productName && val.mg == data.mg)

        console.log(obj, orderListDetails)
        let arr = [...orderList]
        arr[index] = obj
        setOrderList(arr)


    }
    return (
        <Card style={{ height: '100vh', margin: '15px', display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ margin: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant='h1' >Request For Medication</Typography>
                <SaveButton isLoading={isSaveLoading} onClick={submit} title={'Request'} />
                {openOtherVendor && <RFTSOtherVendors
                    handleSubmit={handleSubmit}
                    watch={watch}
                    control={control}
                    errors={errors}
                    sameProduct={sameProduct}
                    setSameProduct={setSameProduct}
                    zeroItems={zeroItems}
                    setZeroItems={setZeroItems}
                    open={openOtherVendor}
                    setOpen={setOpenOtherVendor}
                    otherVendor={otherVendor}
                />}
            </Box>
            {/* <Grid container >
                <Grid item xs={4} style={{ display: 'flex', alignItems: 'center' }}>
                    <SearchBar placeholder={'Search...'} handleChange={setSearch} />
                </Grid>
                <Grid item xs={4} style={{ display: 'flex', alignItems: 'center' }}>

                </Grid>
                <Grid item xs={4} style={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
                    <Autocomplete
                        disablePortal
                        options={wearhouseList}
                        sx={{ width: '80%' }}
                        size="small"
                        getOptionLabel={(option) => {
                            return wearhouseList.find(e => (e.name == option.name))?.name || ""
                        }}
                        onChange={(_, data) => setWearhouse(data?.id)}
                        renderInput={(params) => <TextField {...params} label="Wearhouses" />}
                    />
                </Grid>
            </Grid> */}
            <Grid container spacing={2}>
                {/* <Grid item xs={12} md={3} >
                            <SearchBar placeholder={'Search...'} handleChange={setSearch} disabled={isLoading} />
                        </Grid> */}
                <Grid item xs={12} md={3} >
                    <InputFields
                        fieldName="Din_Number"
                        type="text"
                        label="Din Number"
                        control={control}
                    />
                </Grid>
                <Grid item xs={12} md={3} >
                    <InputFields
                        fieldName="ProductName"
                        type="text"
                        label="Product Name"
                        control={control}
                    />
                </Grid>
                <Grid item xs={12} md={3} >
                    <InputFields
                        fieldName="Strength"
                        type="text"
                        label="Strength"
                        control={control}
                    />
                </Grid>
                <Grid item xs={12} md={3} >
                    <SelectFields
                        fieldName="Vendor_ID"
                        label="Vendor"
                        control={control}
                        options={vendorList.map(({ name, id }) => {
                            return { label: name, value: id };
                        })}
                    />
                </Grid>
                <Grid item xs={12}>
                    <ButtonContainer>
                        <Button size="medium" variant="contained" color="secondary" onClick={() => {
                            reset()
                        }}>Clear</Button>
                        <SaveButton isLoading={isLoading} onClick={fetchList} title={'Search'} />
                    </ButtonContainer>
                </Grid>
            </Grid>

            {orderList.length > 0 && <SelectedProduct
                title={"Selected:"}
                selectedHeader={selectedHeader}
                selectedParam={selectedParam}
                list={orderList.map(e => {
                    return ({
                        ...orderListDetails.filter(val => val.product_ID == e.Product_ID)[0],
                        Qty: e?.Qty,
                        PackSize: e.PackSize
                    })
                })
                }
                onRemove={onRemove}
            />}
            <Card style={{ flex: 1, display: 'flex', flexDirection: 'column', margin: '0px', padding: '0px', }}>
                <TableContainer tableHeader={tableHeader}
                    data={Products.filter(val => String(val?.diN_Master).includes(search) || val.productName.toLowerCase().includes(search.toLowerCase()))}
                    verifyParam={verifyParam}
                    isLoading={isLoading}
                    count={wearhouse ? wearhouseProductPagingcount : 0}
                    fetchList={fetchList}
                    action={(data) => <TableAction data={data} />}
                    actionText={"Request"} />
            </Card>
        </Card>
    );
};

export default RFTS;
